// extracted by mini-css-extract-plugin
module.exports = {"root":"columnLine_root__q12_V"};